/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
import React from 'react'
import Firebase from 'firebase/app'
import { omit, size } from 'lodash'
import moment from 'moment'
import { Modal, Header, Form, Button, Menu, Icon, Segment, Divider } from 'semantic-ui-react'

import DateField from '../../../../components/promotions/fields/dateField'
import ImagePicker from '../../../../components/common/imagePicker'
import ImageUploader from '../../../../services/ImageUpload'

const styles = {
  modal: {
    height: 'calc(100vh - 300px)',
    overflow: 'auto'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  menuWrapper: {
    position: 'relative',
  },
  menuOverlay: {
    width: '100%',
    height: '273px',
    position: 'absolute',
    top: 0,
    opacity: 0.9,
    backgroundColor: 'white'
  },
  menu: {
    width: '100%',
    height: '273px',
    overflow: 'auto',
  },
  item: {
    padding: '13px 10px',
    borderRadius: 0
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  itemName: {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    display: 'flex',
    flex: 1,
    fontSize: 15,
  },
  validationWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  removeValidation: {
    position: 'absolute',
    right: -15,
    top: -15
  },
  validationItemRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
}


export default class FreeCheckoutForm extends React.PureComponent {
  state = {
    id: null,
    title: '',
    merchants: {},
    redemptions: 0,
    startedAt: Number(moment().startOf('day').format('x')),
    endedAt: Number(moment().endOf('day').format('x')),
    validations: [],
    restrictedAge: false,
    allMerchants: false,

    search: '',
    saving: false,
    tab: 'info',
    showSelected: false,
  }

  componentDidMount() {
    const { freeCheckout } = this.props

    if (freeCheckout) {
      this.setState({
        id: freeCheckout.id,
        title: freeCheckout.title,
        endedAt: freeCheckout.ended_at,
        startedAt: freeCheckout.started_at,
        merchants: freeCheckout.merchants,
        redemptions: freeCheckout.redemptions,
        validations: freeCheckout.validations,
        allMerchants: freeCheckout.all_merchants,
        restrictedAge: freeCheckout.restricted_age,

      })
    } else {
      const { id } = Firebase.firestore().collection('free_checkout_promotions').doc()
      const validationId = `validations-${Date.now()}`
      const itemId = `items-${Date.now()}`

      this.setState({
        id,
        validations: [{
          id: validationId,
          items: [{ id: itemId }]
        }],
      })
    }
  }

  afterUpload = async (file, name, imageUrl, validationId, itemId) => {
    try {
      const imageUploader = new ImageUploader(file, name, {
        destination: 'images/app-customization/entry/categories',
        originalUrl: imageUrl,
        type: 'entcat_image',
        manipulation: {
          width: 700,
          height: 0,
          size: 15000,
        },
      })

      const { data } = await imageUploader.createWebpVersion()

      this.onItemChange(validationId, itemId, 'compress_image_url', data)
    } catch (err) {
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  onMerchantClick = merchantKey => {
    const { merchants } = this.state

    if (merchants[merchantKey]) this.setState({ merchants: omit(merchants, merchantKey) })
    else this.setState({ merchants: Object.assign({}, merchants, { [merchantKey]: true }) })
  }

  onAddValidation = () => {
    const { validations } = this.state

    this.setState({ validations: validations.concat({
      id: `validations-${Date.now()}`,
      items: [{ id: `items-${Date.now()}`}]
    })})
  }

  onRemoveValidation = id => {
    const { validations } = this.state

    this.setState({ validations: validations.filter(val => val.id !== id) })
  }

  onAddItem = validationId => {
    const { validations } = this.state

    const newValidations = validations.map(validation => {
      if (validationId === validation.id) {
        const items = [...validation.items, { id: `items-${Date.now()}` }]

        return Object.assign({}, validation, { items })
      }

      return validation
    })

    this.setState({ validations: newValidations })
  }

  onRemoveItem = (validationId, itemId) => {
    const { validations } = this.state

    const newValidations = validations.map(validation => {
      if (validationId === validation.id) {
        const items = validation.items.filter(item => itemId !== item.id)

        return Object.assign({}, validation, { items })
      }

      return validation
    })

    this.setState({ validations: newValidations })
  }

  onValidationChange = (id, field, value) => {
    const { validations } = this.state

    const newValidations = validations.map(validation => {
      if (id === validation.id) validation[field] = value

      return validation
    })

    this.setState({ validations: newValidations })
  }

  onItemChange = (validationId, itemId, field, value) => {
    const { validations } = this.state

    const newValidations = validations.map(validation => {
      if (validationId  === validation.id) {
        const items = validation.items.map(item => {
          if (item.id === itemId) return { ...item, [field]: value }

          return item
        })

        return Object.assign({}, validation, { items })
      }

      return validation
    })

    this.setState({ validations: newValidations })
  }

  onDateChange = (field, value) => {
    if (field === 'startedAt') {
      this.setState({
        startedAt: Number(
          moment(value, 'YYYY-MM-DD')
            .startOf('day')
            .format('x')
        ),
      })
    } else {
      this.setState({
        endedAt: Number(
          moment(value, 'YYYY-MM-DD')
            .endOf('day')
            .format('x')
        ),
      })
    }
  }

  onPrevClick = () => {
    this.setState({ tab: 'info' })
  }

  onNextClick = () => {
    const { tab } = this.state

    if (tab === 'info') this.setState({ tab: 'validations' })
    else this.onSaveClick()
  }

  onSaveClick = async () => {
    const { onClose, freeCheckout } = this.props
    const { id, title, merchants, redemptions, validations, startedAt, endedAt, restrictedAge, allMerchants } = this.state

    try {
      this.setState({ saving: true })

      const originalMerchants = (freeCheckout && freeCheckout.merchants) || {}
      const formatedMerchants = Object.assign({}, merchants)

      Object.keys(originalMerchants).forEach(merchantKey => {
        if (!formatedMerchants[merchantKey])
          formatedMerchants[merchantKey] = Firebase.firestore.FieldValue.delete()
      })

      const params = {
        title,
        redemptions,
        validations,
        ended_at: endedAt,
        started_at: startedAt,
        all_merchants: allMerchants,
        merchants: formatedMerchants,
        restricted_age: restrictedAge,
        updated_at: Number(moment().format('x')),
      }

      if (!freeCheckout) params.created_at = Number(moment().format('x'))

      const collection = Firebase.firestore().collection('free_checkout_promotions')

      await collection.doc(id).set(params, { merge: true })

      this.setState({ saving: false }, () => onClose())
    } catch (err) {
      alert(err.message || err)
    }
  }

  renderMerchants = () => {
    const { merchants } = this.props
    const { search, merchants: selectedMerchants, showSelected, allMerchants } = this.state

    const displayMerchants = []
    const merchantCount = merchants.length

    for (let index = 0; index < merchantCount; index += 1) {
      const merchant = merchants[index]
      const shouldShow = !showSelected || selectedMerchants[merchant.key]
      const merchantName = merchant.name.toLowerCase()
      const searchText = search.toLowerCase()

      if (merchantName.includes(searchText) && merchant.status === 'publish' && shouldShow)
        displayMerchants.push(merchant)
    }

    return (
      <div style={styles.menuWrapper}>
        <Menu vertical style={styles.menu} className="hide-scrollbar">
          {
            displayMerchants.map(merchant => (
              <Menu.Item
                key={merchant.key}
                active={selectedMerchants[merchants.key]}
                onClick={() => this.onMerchantClick(merchant.key)}
                style={styles.item}
              >
                <div style={styles.itemRow} >
                  <div style={styles.itemName}>
                    {merchant.name}
                  </div>
                  {selectedMerchants[merchant.key] && <Icon name="check" color="green" />}
                </div>
              </Menu.Item>
            ))
          }
        </Menu>
        {allMerchants && <div style={styles.menuOverlay} />}
      </div>
    )
  }

  renderInfoTab = () => {
    const { title, merchants, redemptions, showSelected, startedAt, endedAt, restrictedAge, allMerchants } = this.state

    return (
      <React.Fragment>
        <Form.Group widths="equal">
          <Form.Input
            label="Title"
            required
            placeholder="Ex: Free Pepsi"
            value={title}
            onChange={e => this.setState({ title: e.target.value })}
          />
          <Form.Input
            label="Redemptions per user"
            type="number"
            value={redemptions}
            onChange={e => this.setState({ redemptions: Number(e.target.value) })}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <DateField
            label="Start Date"
            onChange={value => this.onDateChange('startedAt', value)}
            value={startedAt}
          />
          <DateField
            label="End Date"
            onChange={value => this.onDateChange('endedAt', value)}
            value={endedAt}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Select
            label="Restricted Age"
            options={[{ key: 'yes', value: true, text: 'Yes' }, { key: 'no', value: false, text: 'No' }]}
            value={restrictedAge}
            onChange={(e, data) => this.setState({ restrictedAge: data.value })}
          />
          <Form.Select
            label="Eligible to All Merchants"
            options={[{ key: 'yes', value: true, text: 'Yes' }, { key: 'no', value: false, text: 'No' }]}
            value={allMerchants}
            onChange={(e, data) => this.setState({ allMerchants: data.value })}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Merchants"
            icon="search"
            placeholder="Search"
            disabled={allMerchants}
            onChange={e => this.setState({ search: e.target.value })}
          />
          <Form.Checkbox
            label={`Show only selected (${size(merchants)})`}
            disabled={allMerchants}
            checked={showSelected}
            style={{ marginTop: 30 }}
            onChange={() => this.setState({ showSelected: !showSelected })}
          />
        </Form.Group>
        {this.renderMerchants()}
      </React.Fragment>
    )
  }

  renderValidationTab = () => {
    const { validations } = this.state

    return (
      <div style={styles.validationWrapper}>
        {validations.map(validation => (
          <Segment key={validation.id}>
            <Button
              circular
              size="mini"
              color="red"
              icon="delete"
              style={styles.removeValidation}
              disabled={validations.length === 1}
              onClick={() => this.onRemoveValidation(validation.id)}
            />
            <Form.Group widths="equal">
              <Form.Input
                label="Min Order Value"
                type="number"
                value={validation.min_order}
                onChange={e => this.onValidationChange(validation.id, 'min_order', Number(e.target.value))}
              />
              <Form.Input
                label="Max Order Value"
                type="number"
                value={validation.max_order}
                onChange={e => this.onValidationChange(validation.id, 'max_order', Number(e.target.value))}
              />
            </Form.Group>
            <div style={styles.row}>
              <Header content="Items" style={{ marginBottom: 0 }} />
              <Button icon="add" onClick={() => this.onAddItem(validation.id)} />
            </div>
            <Divider />
            {validation.items.map(item => (
              <div style={styles.validationItemRow} key={item.id}>
                <ImagePicker
                  compress
                  label="Image"
                  url={item.compress_image_url}
                  uploadOriginal={false}
                  compressFileName={item.id}
                  uploadPath="free-checkouts"
                  onCompressCompleted={url => this.onItemChange(validation.id, item.id, 'image_url', url)}
                  afterUpload={(file, name, imageUrl) => this.afterUpload(file, name, imageUrl, validation.id, item.id)}
                />
                <Form.Group widths="equal" style={{ flex: 1, marginLeft: 7, marginRight: 7 }}>
                  <Form.Input
                    label="Name"
                    value={item.name}
                    onChange={e => this.onItemChange(validation.id, item.id , 'name', e.target.value)}
                  />
                  <Form.Input
                    label="Qty"
                    type="number"
                    value={item.qty}
                    onChange={e => this.onItemChange(validation.id, item.id, 'qty', Number(e.target.value))}
                  />
                </Form.Group>
                <Button
                  icon="delete"
                  color="red"
                  style={{ marginTop: 22 }}
                  disabled={validation.items.length === 1}
                  onClick={() => this.onRemoveItem(validation.id, item.id)}
                />
              </div>
            ))}
          </Segment>
        ))}

        <Button icon="add" content="Add New Validation"  onClick={() => this.onAddValidation()} />
      </div>
    )
  }

  render() {
    const { onClose, freeCheckout } = this.props
    const { saving, tab } = this.state

    const title = freeCheckout ? 'Edit Free Checkout Promotion' : 'Add New Free Checkout Promotion'

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content={title} />
        <Modal.Content style={styles.modal} className="hide-scrollbar">
          <Form>
            {tab === 'info' ? this.renderInfoTab() : this.renderValidationTab()}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button floated="left" disabled={saving} onClick={onClose} content="Close" />
          {tab === 'validations' && (
            <Button
              color="black"
              content="Prev"
              disabled={saving}
              onClick={this.onPrevClick}
            />
          )}

          <Button
            color="black"
            content={tab === 'info' ? 'Next' : 'Save'}
            icon={tab === 'validations' ? 'checkmark' : undefined}
            disabled={saving}
            loading={saving}
            onClick={this.onNextClick}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/promotions/components/FreeCheckouts/Form.js